import { Link } from "react-router-dom";
import styles from "./ProfilePublic.module.css";
import translations from './translation.js';


const OwnProfileButtons = () => {
    const currentLanguage = localStorage.getItem('selectedLanguage') || "en";

    return (
        <>
            <Link to="/profile"><button className={styles.ownBtn}>{translations[currentLanguage].edit_profile}</button></Link>
            <Link to="/privacy"><button className={styles.ownBtn}>{translations[currentLanguage].account_settings}</button></Link>
        </>
    );
}

export default OwnProfileButtons;